import ReactHtmlParser from 'html-react-parser';
import * as React from 'react';
import styled from 'styled-components';
import { Col3Col9 } from '../';
import ContentConstants from '../../../contentConstants';
import { ISummaryItem, SummaryDisplayType } from '../../../models';
import { ErrorWarningDisplay } from './ErrorWarningDisplay';
import { NoValue } from './NoValue';
import { SummaryItemDateHelper } from './SummaryItemDateHelper';

export const PlainTextItemLayout = styled.div.attrs<{}>({
	className: 'tws-plain-text-summary-item',
})``;
PlainTextItemLayout.displayName = 'PlainTextItemLayout';

export class PlainTextSummaryItem extends React.Component<ISummaryItem> {
	public render() {
		const { displayName, errors, toolTipText, warnings } = this.props;
		const value = this.getDisplayContent();
		const labelInfo = toolTipText && toolTipText.length > 0 ? toolTipText : undefined;
		const labelInfoTitle = labelInfo !== undefined ? displayName : undefined;

		return (
			<Col3Col9 label={displayName} labelSize='md' labelInfo={labelInfo} labelInfoTitle={labelInfoTitle}>
				<PlainTextItemLayout>
					{value !== null && ReactHtmlParser(value)}
					{value === null && NoValue}
					<ErrorWarningDisplay errors={errors} warnings={warnings} />
				</PlainTextItemLayout>
			</Col3Col9>
		);
	}

	private getDisplayContent() {
		const { displayType, value } = this.props;
		switch (displayType) {
			case SummaryDisplayType.PlainText:
				return value;
			case SummaryDisplayType.Date:
				return SummaryItemDateHelper.getDate(value);
			case SummaryDisplayType.DateRange:
				if (!value) {
					return null;
				}

				if (value.openImmediately && !value.openOn) {
					const closeOn = SummaryItemDateHelper.getDate(value.closeOn);
					return `${ContentConstants.AUDIENCE_OPENCLOSEDATES_OPENIMMEDIATELY} - ${closeOn}`;
				}
				return SummaryItemDateHelper.getDateRange([value.openOn, value.closeOn]);
		}
	}
}
